import gql from 'graphql-tag';

export const DraftSyncMutation =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		mutation DraftSyncMutation(
			$contentId: ID!
			$contentType: String!
			$content: String!
			$title: String
			$ncsStepVersion: String!
		) @experimental {
			experimentalDraftSync(
				contentId: $contentId
				contentType: $contentType
				content: $content
				title: $title
				ncsStepVersion: $ncsStepVersion
				updateTrigger: "DRAFT_SYNC"
			) {
				id
			}
		}
	`;
